module.exports = __webpack_public_path__ + "media/7 Ninja Clan.89fc6e8e.mp3";